import React from 'react';
import { MARKETING_NAME } from '../../support/brand';
import { COMPANY_NAME, COMPANY_CNPJ } from '../../support/legal';
import { PANEL_LOGIN_URL, PANEL_PRIVACY_URL, PANEL_TERMS_URL } from '../../support/publicUrls';

function MaiaPublicFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-[var(--maia-line)] bg-[var(--maia-paper-2)]">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-4 py-12 sm:flex-row sm:px-6 lg:px-8">
        <div className="flex flex-col items-center sm:items-start">
          <span className="font-display text-2xl text-[var(--maia-ink)]">{MARKETING_NAME}</span>
          <span className="mt-1 text-xs text-[var(--maia-faint)]">Mentoria digital no WhatsApp</span>
        </div>

        <nav className="flex flex-wrap items-center justify-center gap-5">
          <a
            href="/"
            className="text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)]"
          >
            Plataforma
          </a>
          <a
            href="/agente-ia-whatsapp"
            className="text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)]"
          >
            IA WhatsApp
          </a>
          <a
            href="/artigos"
            className="text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)]"
          >
            Artigos
          </a>
          <a
            href={PANEL_LOGIN_URL}
            className="text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)]"
          >
            Entrar
          </a>
          <a
            href={PANEL_PRIVACY_URL}
            className="text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)]"
          >
            Privacidade
          </a>
          <a
            href={PANEL_TERMS_URL}
            className="text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)]"
          >
            Termos
          </a>
        </nav>

        <div className="text-center text-xs text-[var(--maia-faint)] sm:text-right">
          <p>{`© ${year} ${MARKETING_NAME}`}</p>
          <p className="mt-0.5">{`${COMPANY_NAME} · ${COMPANY_CNPJ}`}</p>
        </div>
      </div>
    </footer>
  );
}

export default MaiaPublicFooter;
